
<template>
  <v-app id="onIndd">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{indd.indd_nr}}  

      <span v-for="(inddtaalRecord,i) in indd.inddtaal" :key="i">
       <br>
       {{inddtaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveInddtaal(inddtaalRecord)">Save</v-btn><br>
       <v-textarea v-model="inddtaalRecord.inddtaal_oms" :value=inddtaalRecord.inddtaal_oms rows="1" label="Translation" spellcheck="false"></v-textarea>
       <br>
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['indd_encrid'],
  data() {
    return {
      indd: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/indd/getIndd.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getIndd"
          },
          getIndd: {
             indd_encrid: this.indd_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.indd = res.data.getIndd;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveInddtaal(inddtaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/indd/saveInddtaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveInddtaal"
          },
          saveInddtaal: {
            inddtaal: inddtaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveInddtaal.text,
              color: res.data.saveInddtaal.color
            });
          }
        })
    }
  }  

};

</script> 
